import { render } from "./PurchaseReturnListPage.vue?vue&type=template&id=775ef2f8&ts=true"
import script from "./PurchaseReturnListPage.vue?vue&type=script&lang=ts"
export * from "./PurchaseReturnListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__